import { css, type Theme } from "@emotion/react";

export const list = css`
  list-style: none;
  margin-left: 0;
`;

export const listItem = css`
  position: relative;
  list-style-type: none;
  padding: 0.25rem 0 0;
  display: flex;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 0.25rem;
  }
`;

export const icon = (theme: Theme) => css`
  margin-right: 0.75rem;
  color: ${theme.success.textBase};
`;

export const circleIcon = css`
  margin-right: 1rem;
`;
